import { EMPTY_FIELD } from 'constants/emptyField';
import { Resource } from 'constants/resources';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { CreatePathType, RaRecord } from 'react-admin';
import { Link as RouterLink } from 'react-router-dom';
import { Chip } from 'shared/mui/Chips';
import { Link } from 'shared/mui/Link/Link';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';

export type LinkChipFieldProps = {
  nameSourceField?: string;
  idSourceField?: string;
  linkType?: CreatePathType;
  resource: Resource;
} & Omit<FunctionFieldProps, 'render' | 'source'>;

export const LinkChipField: React.FC<LinkChipFieldProps> = ({
  label,
  resource,
  linkType = 'show',
  idSourceField = '@id',
  nameSourceField = 'name',
  ...restProps
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();

  return (
    <FunctionField
      render={(record: RaRecord) => {
        const { [nameSourceField]: entityName, [idSourceField]: entityId } = record ?? {};
        return (
          <Chip
            label={
              <>
                {`${label}: `}
                {entityName ? (
                  <Link
                    component={RouterLink}
                    sx={{ color: 'primary.main' }}
                    to={createPathWithQuery({
                      resource,
                      id: entityId,
                      type: linkType,
                    })}
                  >
                    {entityName}
                  </Link>
                ) : (
                  EMPTY_FIELD
                )}
              </>
            }
            size="small"
          />
        );
      }}
      {...restProps}
    />
  );
};
